import type {ReactNode} from "react";
import {Box, Typography} from "@mui/material";

interface Props {
    label: string,
    value: string | number | undefined | null | ReactNode,
}

export function TicketField({label, value}: Props) {
    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: 'minmax(150px, 1fr) 3fr',
                minHeight: '48px',
                borderBottom: '1px solid #E6E6E6',
                '&:last-child': {
                    borderBottom: '1px solid transparent',
                },
            }}
        >
            <Typography
                sx={{
                    padding: '16px',
                    color: '#05304F7A',
                }}
            >
                {label}
            </Typography>
            <Typography
                component={'div'}
                sx={{
                    color: '#05304F',
                    padding: '16px',
                    wordBreak: 'break-word',
                }}
            >
                {value}
            </Typography>
        </Box>
    );
}